module.exports = __webpack_public_path__ + "static/img/about-certificate-06.ce3dc57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-06.jpg
// module id = cQyw
// module chunks = 1